interface MetricListProps {
  metricName: string;
  metricValue: string | number;
  metricDetails: string;
  metricUnit: string;
}

interface CustomDimensionsProps {
  dimensionName: string;
  dimensionValue: string;
}

interface PropertyProps {
  propertyName: string;
  propertyValue: string;
}

interface CustomOpsMetricsProps {
  metricList: Array<MetricListProps>;
  customDimensions?: Array<CustomDimensionsProps>;
  customAggregations?: Array<Array<string>>;
  properties?: Array<PropertyProps>;
}

export const addCustomOpsMetric = (opsMetrics: CustomOpsMetricsProps) => {
  if (window.panorama) {
    window.panorama(
      'trackOperationalEvents',
      {
        metricList: opsMetrics.metricList,
        customDimensions: opsMetrics.customDimensions,
        customAggregations: opsMetrics.customAggregations,
      },
      opsMetrics.properties
    );
  }
};
